import styled from 'styled-components';

export const Section = styled.div`
    background: #fff;
    padding: 24px 22px 24px 24px;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    @media (max-width: 768px) {
        padding: 16px;
        border-radius: 20px;
        gap: 12px;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    background-color: #E9E9E9;

    @media (max-width: 768px) {
        gap: 12px;
        border-radius: 30px;
    }
`;

export const Title = styled.h2`
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #000000;
    font-family: SF Pro Display, sans-serif;

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 20px;
    }
`;

export const Label = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #00000080;
    font-family: SF Pro Display, sans-serif;

    @media (max-width: 768px) {
        font-size: 12px;
    }
`;

export const Amount = styled.div`
    color: #000000;
    font-family: Outfit;
    font-weight: 500;
    font-size: 30px;
    leading-trim: NONE;
    line-height: 33px;
    letter-spacing: 0;
    vertical-align: middle;

    @media (max-width: 768px) {
        font-size: 28px;
    }
`;
